<template>
  <a-dialog v-model="isOpen" scrollable persistent max-width="650px">
    <v-card flat>
      <v-toolbar color="primaryLight1" dark height="50px">
        <span>{{ $t("statistics.hSetParameter") }}</span>
        <v-spacer></v-spacer>
        <CloseIcon @click="close()" />
      </v-toolbar>

      <v-card-text>
        <v-row>
          <v-form
            ref="refAttendanceForm"
            v-model="validDate"
            lazy-validation
            style="display: contents"
          >
            <v-col cols="12">
              <v-row no-gutters>
                <v-col cols="2" class="text-right mr-3 mt-2">
                  {{ $t("search.startDate") }}:
                </v-col>
                <v-col cols="8">
                  <v-menu
                    v-model="calmenu"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        class="dateField"
                        ref="reffromdaterange"
                        v-model="formatStartDate"
                        append-icon="mdi-calendar"
                        single-line
                        dense
                        :label="`${$t('search.startDate')} *`"
                        :placeholder="`${$t('search.startDate')} *`"
                        hide-details="auto"
                        v-bind="attrs"
                        v-on="on"
                        readonly
                        required
                        :rules="startDateRule"
                        outlined
                        @click:append="calmenu = true"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="statisticsInput.startDate"
                      :max="currentDate"
                      :locale="selectedLang"
                      color="appMenu lighten-1"
                      @input="calmenu = false"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12">
              <v-row no-gutters class="py-2">
                <v-col cols="2" class="text-right mr-3 mt-2">
                  {{ $t("search.endDate") }}:
                </v-col>
                <v-col cols="8">
                  <v-menu
                    v-model="calmenu2"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        class="dateField"
                        ref="reffromdaterange"
                        v-model="formatEndDate"
                        append-icon="mdi-calendar"
                        single-line
                        dense
                        :label="`${$t('search.endDate')} *`"
                        :placeholder="`${$t('search.endDate')} *`"
                        hide-details="auto"
                        v-bind="attrs"
                        v-on="on"
                        readonly
                        required
                        :rules="endDateRule"
                        outlined
                        @click:append="calmenu2 = true"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="statisticsInput.endDate"
                      :min="statisticsInput.startDate"
                      :locale="selectedLang"
                      color="appMenu lighten-1"
                      @input="calmenu2 = false"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12">
              <v-row no-gutters class="">
                <v-col cols="2" class="text-right mr-3 mt-2">
                  {{ $t("agenda.lblMeetingType") }}:
                </v-col>
                <v-col cols="8">
                  <v-select
                    class="selectField"
                    v-model="statisticsInput.meetingType"
                    :items="meetingTypesList"
                    :label="`${$t('agenda.lblMeetingType')} *`"
                    :placeholder="`${$t('agenda.lblMeetingType')} *`"
                    :rules="[(v) => !!v || $t('agenda.ruleMeetingTypeReq')]"
                    required
                    single-line
                    dense
                    :menu-props="{ bottom: true, offsetY: true }"
                    item-text="label"
                    item-value="id"
                    return-object
                    @focus="focusSelect"
                    ref="refMeetingType"
                    id="meetingType"
                    outlined
                    :no-data-text="noMeetingTypeMsg"
                  >
                    <template v-slot:item="{ item }">
                      <span>{{ item.label }}</span>
                      <v-spacer></v-spacer>
                    </template>
                  </v-select>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12">
              <v-row no-gutters>
                <v-col cols="2" class="text-right mr-3 mt-2">
                  {{ $t("admin.users") }}:
                </v-col>
                <v-col cols="8">
                  <v-combobox
                    v-model="statisticsInput.selectedEmail"
                    :items="users"
                    :filter="filter"
                    :search-input.sync="resultSearch"
                    :rules="emailRules"
                    required
                    ref="combobox"
                    class="searchComboBox"
                    id="searchComboBox"
                    :label="`${$t('admin.lblSelectEmail')} *`"
                    :placeholder="`${$t('admin.lblSelectEmail')} *`"
                    single-line
                    dense
                    clearable
                    chips
                    multiple
                    outlined
                    @input="resultSearch = null"
                    item-text="registered_email"
                    item-value="id"
                    return-object
                    :autocomplete="comboboxAutoSuggest"
                    @focus="comboboxAutoSuggest = 'on'"
                    @blur="comboboxAutoSuggest = 'none'"
                    :no-data-text="$t('noData')"
                  >
                    <template v-slot:no-data>
                      <v-list-item>
                        <v-list-item-content>
                          <v-list-item-title>
                            {{ $t("noData") }}
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </template>
                    <template v-slot:selection="data">
                      <v-chip
                        small
                        :key="JSON.stringify(data.item)"
                        v-bind="data.attrs"
                        :input-value="data.selected"
                        :disabled="data.disabled"
                        @click:close="data.parent.selectItem(data.item)"
                        close
                        color="secondary darken-3"
                        class="ma-1 pl-2"
                      >
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-avatar
                              v-if="data.item.registered_email"
                              left
                              v-bind="attrs"
                              v-on="on"
                            >
                              <v-img
                                v-if="data.item.profilePhoto"
                                contain
                                :src="data.item.profilePhoto"
                              ></v-img>
                              <v-img
                                v-else
                                contain
                                src="@/assets/images/NoPhotoIcon.png"
                              ></v-img>
                            </v-avatar>
                            <span
                              v-if="data.item.firstName"
                              v-bind="attrs"
                              v-on="on"
                            >
                              {{
                                data.item.firstName + " " + data.item.lastName
                              }}
                            </span>
                            <span v-else v-bind="attrs" v-on="on">
                              {{ data.item.registered_email }}</span
                            >
                          </template>
                          <span
                            >{{ $t("lblEmail") }}:
                            {{ data.item.registered_email }}</span
                          >
                        </v-tooltip>
                      </v-chip>
                    </template>
                    <template v-slot:item="{ item }">
                      <v-list color="#FFF" class="combo-list ma-0 pa-0">
                        <v-list-item
                          v-if="
                            Boolean(item.is_registered_user) &&
                            item.registered_email
                          "
                          :class="[
                            itemSelected(item.registered_email)
                              ? 'selected-removed'
                              : '',
                          ]"
                          @click.stop.prevent="selectEmail(item)"
                        >
                          <v-list-item-avatar class="mt-0 mb-0 mr-2" size="40">
                            <v-img
                              v-if="item.profilePhoto"
                              contain
                              :src="item.profilePhoto"
                            ></v-img>
                            <v-img
                              v-else
                              contain
                              src="@/assets/images/NoPhotoIcon.png"
                            ></v-img>
                          </v-list-item-avatar>
                          <v-list-item-content>
                            <v-list-item-title>
                              <label>
                                <span v-if="item.firstName">
                                  {{ item.firstName + " " + item.lastName }}
                                </span>
                                <span v-else>{{
                                  item.display_email
                                    ? item.display_email
                                    : item.registered_email
                                }}</span>
                              </label>
                            </v-list-item-title>
                            <v-list-item-subtitle v-if="item.firstName">
                              <label>
                                {{
                                  item.display_email
                                    ? item.display_email
                                    : item.registered_email
                                }}
                              </label>
                            </v-list-item-subtitle>
                          </v-list-item-content>
                          <v-list-item-avatar
                            class="mt-0 mb-0 mr-2"
                            size="40"
                            v-if="itemSelected(item.registered_email)"
                          >
                            <v-icon color="green" left>mdi-check </v-icon>
                          </v-list-item-avatar>
                          <v-list-item-action style="flex-direction: inherit">
                            <v-btn
                              outlined
                              x-small
                              color="primaryDark"
                              v-if="
                                item.is_registered_user === true &&
                                item.registered_email
                              "
                            >
                              {{ $t("admin.lblRegistered") }}
                            </v-btn>
                          </v-list-item-action>
                        </v-list-item>
                      </v-list>
                    </template>
                  </v-combobox>
                </v-col>
              </v-row>
            </v-col>
          </v-form>
        </v-row>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <a-btn
              v-bind="attrs"
              v-on="on"
              class="mr-2 primaryDark"
              @click="onSave()"
              >{{ $t("btnOk") }}</a-btn
            >
          </template>
          <span>{{ $t("btnOk") }}</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <a-btn
              v-bind="attrs"
              v-on="on"
              class="secondary"
              @click="close()"
              >{{ $t("btnLabelCancel") }}</a-btn
            >
          </template>
          <span>{{ $t("btnLabelCancel") }}</span>
        </v-tooltip>
      </v-card-actions>
    </v-card>
  </a-dialog>
</template>

<script>
import Vue from "vue";
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import { DatePickerPlugin } from "@syncfusion/ej2-vue-calendars";
import { formatDate } from "@/utils/util";
Vue.use(DatePickerPlugin);
export default {
  name: "FilterDialog",
  data() {
    return {
      noMeetingTypeMsg: this.$t("noData"),
      calmenu: false,
      calmenu2: false,
      validDate: true,
      comboboxAutoSuggest: "none",
      resultSearch: null,
      meetingObject: this.selectedMeeting,
      statisticsInput: {
        meetingType: "",
        startDate: new Date().toISOString().slice(0, 10),
        endDate: new Date().toISOString().slice(0, 10),
        selectedEmail: [],
      },
      isValidEndDate: false,
      emailRules: [
        (v) => !!(v && this.emailRequired(v)) || this.$t("ruleEmailReq"),
      ],
      startDateRule: [(v) => !!v || this.$t("lblSelectDate")],
      endDateRule: [(v) => !!v || this.$t("lblSelectDate")],
      filterPayload: null,
    };
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    hasCalledFromStatistics: {
      type: Boolean,
      default: false,
    },
  },
  async mounted() {
    const comboElem = document.getElementById("searchComboBox");
    if (comboElem) {
      comboElem.setAttribute("autocomplete", "none");
    }
    let statisticsFilterInputs = sessionStorage.getItem(
      "statisticsFilterInputs"
    );
    statisticsFilterInputs = JSON.parse(statisticsFilterInputs);
    if (statisticsFilterInputs && !this.hasCalledFromStatistics) {
      this.statisticsInput.startDate = statisticsFilterInputs?.start_date;
      this.statisticsInput.endDate = statisticsFilterInputs?.end_date;
      this.statisticsInput.meetingType =
        statisticsFilterInputs?.meeting_type_id;

      this.statisticsInput.selectedEmail = this.userList.filter((user) =>
        statisticsFilterInputs?.user_ids.includes(user.id)
      );
    }
  },
  methods: {
    ...mapActions({
      getStatisticsData: "admin/getStatisticsData",
    }),
    formatDate,
    selectEmail(item) {
      const existItem = this.statisticsInput.selectedEmail.findIndex(
        (selected) => selected.id === item.id
      );
      if (existItem !== -1) {
        this.statisticsInput.selectedEmail.splice(existItem, 1);
      } else {
        this.statisticsInput.selectedEmail.push(item);
      }
    },
    close() {
      this.$refs.refAttendanceForm.resetValidation();
      this.isOpen = false;
    },
    async onSave() {
      if (this.$refs.refAttendanceForm.validate()) {
        this.meetingTypesList.forEach((meetType) => {
          if (this.statisticsInput.meetingType === meetType.id) {
            this.statisticsInput.meetingType = meetType;
          }
        });
        let userIds = this.statisticsInput.selectedEmail.map((obj) => {
          return obj.id;
        });
        const data = {
          start_date: this.statisticsInput.startDate,
          end_date: this.statisticsInput.endDate,
          meeting_type_id: this.statisticsInput.meetingType?.id,
          user_ids: userIds,
        };

        await this.getStatisticsData(data)
          .then(() => {
            sessionStorage.setItem(
              "statisticsFilterInputs",
              JSON.stringify(data)
            );
            this.$emit("sessionFilterPayload", data);
            if (
              this.$route.path !== "/statistics&analysis/attendanceanalysis"
            ) {
              this.$router.push({
                path: "/statistics&analysis/attendanceanalysis",
              });
            } else {
              this.close();
            }
          })
          .catch((error) => {
            console.error(error);
          });
      }
    },
    focusSelect(e) {
      this.scrolling(e.srcElement);
    },
    scrolling(element) {
      let dialogCardEl = document.getElementById("dialog-card-text");
      if (dialogCardEl) {
        dialogCardEl.addEventListener("scroll", (event) => {
          if (element && element.id == "meetingType") {
            if (this.$refs.refMeetingType.$refs.input) {
              this.$refs.refMeetingType.blur();
            }
          } else if (element && element.id == "resType") {
            if (this.$refs.refResType.$refs.input) {
              this.$refs.refResType.blur();
            }
          }
        });
      }
    },
    filter(item, queryText) {
      const hasValue = (val) => (val != null ? val : "");
      const query = hasValue(queryText);
      return (
        (item.firstName &&
          item.firstName
            .toLowerCase()
            .indexOf(query.toString().toLowerCase()) !== -1) ||
        (item.lastName &&
          item.lastName
            .toLowerCase()
            .indexOf(query.toString().toLowerCase()) !== -1) ||
        (item.contactEmailIds &&
          item.contactEmailIds.filter(
            (email) =>
              email &&
              email.toLowerCase().indexOf(query.toString().toLowerCase()) !== -1
          ).length > 0)
      );
    },
    itemSelected(itemEmail) {
      const selectedIndex =
        this.statisticsInput.selectedEmail &&
        this.statisticsInput.selectedEmail.length > 0
          ? this.statisticsInput.selectedEmail.findIndex(
              (attendee) => attendee.registered_email === itemEmail
            )
          : -1;
      return selectedIndex !== -1;
    },
    emailRequired(data) {
      return data.length;
    },
  },
  watch: {
    "statisticsInput.selectedEmail"(val) {
      let entry =
        this.statisticsInput.selectedEmail[
          this.statisticsInput.selectedEmail.length - 1
        ];
      if (entry && typeof entry !== "object") {
        let index = this.statisticsInput.selectedEmail.indexOf(entry);
        if (index > -1) {
          this.statisticsInput.selectedEmail.splice(index, 1);
        }
      }
    },
    "statisticsInput.startDate": {
      immediate: true,
      handler(date) {
        if (
          date > this.statisticsInput.endDate &&
          this.statisticsInput.endDate != ""
        ) {
          this.statisticsInput.endDate = this.currentDate;
        }
      },
    },
    "statisticsInput.endDate": {
      immediate: true,
      handler(endDate) {
        if (endDate === null || this.statisticsInput.endDate == "") {
          this.isValidEndDate = true;
        } else this.isValidEndDate = false;
      },
    },
  },
  computed: {
    ...gettersMap(),
    ...mapState({
      userList: (state) => state.people.userList,
    }),
    dateFormat() {
      return this.selectedLang !== "ja" ? "dd-MM-yyyy" : "yyyy-MM-dd";
    },
    formatStartDate: {
      get() {
        return this.formatDate(
          new Date(this.statisticsInput.startDate),
          this.dateFormat
        );
      },
      set(value) {
        this.$emit("input", value || "");
      },
    },
    formatEndDate: {
      get() {
        return this.formatDate(
          new Date(this.statisticsInput.endDate),
          this.dateFormat
        );
      },
      set(value) {
        this.$emit("input", value || "");
      },
    },
    selectedLang() {
      return this.$i18n.locale;
    },
    isOpen: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value || false);
      },
    },
    users() {
      return this.userList.filter(
        (user) => Boolean(user.is_registered_user) && user.registered_email
      );
    },
    loaderText() {
      return this.$t("LoaderText");
    },
    currentDate() {
      return new Date().toISOString().slice(0, 10);
    },
    meetingTypesList() {
      let list = [];
      if (this.meetingTypes && this.meetingTypes.length > 0) {
        list = this.meetingTypes.filter((item) =>
          this.$security.checkMeetingTypeAccess(item.id, "ViewMeeting")
        );
        this.noMeetingTypeMsg = !list.length
          ? this.$t("noMeetingTypeData")
          : "";
        return list;
      } else {
        this.noMeetingTypeMsg = this.$t("noData");
      }
    },
  },
};
function gettersMap() {
  return mapGetters({
    meetingTypes: "tenant/agendaMeetingTypes",
  });
}
</script>

<style scoped>
.searchComboBox /deep/ .v-input__control > .v-input__slot {
  color: var(--v-neutralGray-base) !important;
}
.v-list-item:has(.combo-list) {
  margin: 0px !important;
  padding: 0px !important;
}
.combo-list {
  width: 100%;
}
.combo-list .v-list-item {
  width: 100%;
  cursor: pointer;
}
.combo-list .v-list-item:hover {
  background-color: #e6e6e6 !important;
}
.combo-list .v-list-item.selected {
  background-color: paleturquoise !important;
}
.combo-list .v-list-item label {
  cursor: pointer;
}
::v-deep .e-date-wrapper {
  border: 1px solid gray !important;
  border-radius: 4px !important;
  padding-left: 5px !important;
  padding-right: 5px !important;
  height: 40px;
  font-size: 15px !important;
}

::v-deep .e-date-wrapper .e-input-group-icon {
  min-height: 18px !important;
  min-width: 18px !important;
}
.selectField /deep/ .v-label {
  line-height: 19px !important;
}
.selectField /deep/ .v-select__selections {
  line-height: 21px !important;
}
</style>